import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TabContainerComponent } from '../dynamic-tab/tab-container/tab-container.component';
import { TabComponent } from '../dynamic-tab/tab/tab.component';
import { AuthService } from 'src/app/utilities/auth/auth.service';
import { MsalService } from '@azure/msal-angular';
import { LogoutService } from 'src/app/services/logout.service';
import { Role } from 'src/app/models/auth/role';
import { UserRole } from 'src/app/models/user/userRole';
import { MatDialog } from '@angular/material/dialog';
import { LogoutPatchUploadPopupComponent } from 'src/app/shared/logout-patch-upload-popup/logout-patch-upload-popup.component';
import { BlobServiceClientService } from 'src/app/services/blob-service-client.service';
import { PatchUploadStatus } from 'src/app/models/common/patchUploadStatus';
import { SetServiceKeyComponent } from '../service-user-authentication/set-service-key/set-service-key.component';
import { SUAService } from 'src/app/services/sua.service';
import { UserServiceKeyStatus } from 'src/app/models/user/userServiceKeyStatus';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs';
import { BroadcastMessageEvent } from 'src/app/core/constants/BroadcastMessageEvent';
import { MessageBroadcastService } from 'src/app/services/message-broadcast.service';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit,OnDestroy {
  public username: string = '';
  public userRole: string = '';
  public showConfigurationsTab: boolean = false;
  public loginObject: any = {};
  hideNavBar: boolean = false;
  logoutImgSrc = '../../../assets/icons/user.svg';
  usrImgSrc = '../../../assets/icons/logout.svg';
  public isLogoutClicked : boolean= false;
  public cautionAmberContent: string = "";
  showCautionBanner: boolean = false;
  tooltipDynamicContentValue: string = '';
  dialogData: any = {};
  roleUpdateSubscription:Subscription;
  private suaKeyUpdateSubscription:Subscription;
  constructor(
    private router: Router,
    private authService: AuthService,
    private msalService: MsalService,  
    private logoutService:LogoutService,
    public dialog: MatDialog,
    private blobServiceClientService:BlobServiceClientService,
    private suaService: SUAService,
    private translocoService: TranslocoService,
    private messageBroadcastService:MessageBroadcastService
  ) {
    this.roleUpdateSubscription = this.authService.getRoleUpdate().subscribe(() => {
      this.setInitialValues();
    });
    this.suaKeyUpdateSubscription = this.messageBroadcastService.getSubscription(BroadcastMessageEvent.suaKeyUpdates).subscribe(() => {
      this.getUserServiceKeyStatus();
    });
  }

  ngOnInit(): void {
   this.setInitialValues();
  }

  setInitialValues(){
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // if (event.navigationTrigger == 'popstate') {
        //   this.applyStyleToNavigations(window.location.href);
        // }
      }
      if(event instanceof NavigationEnd){
        this.applyStyleToNavigations(window.location.href);
      }
    });

    this.loginObject = this.authService.userValue;
    this.username = this.loginObject?.name?.split(',')[1]; //to get the display name from full name
    this.userRole = this.loginObject?.userRole == Role.RM ? UserRole.RM : this.loginObject?.userRole;
    if (this.userRole == 'ADMIN') {
      this.showConfigurationsTab = true;
    }
    if (this.userRole == '') {
      this.hideNavBar = true;
    }
    else{
      this.hideNavBar = false;
    }
    this.applyStyleToNavigations(window.location.href);
    this.getUserServiceKeyStatus();
    this.suaService.serviceKeyStatus.subscribe(data=>{
      if(data == "success"){
        this.getUserServiceKeyStatus();
      }
    });
  }

  applyStyleToNavigations(location: string) {
    if (location.substring(location.length - 1, location.length) == '/') {
      this.deviceBackgroundStyle = true;
      this.configBackgroundStyle = false;
      this.patchBackgroundStyle = false;
    }
    if (location.indexOf('deviceDetails') > 0) {
      this.deviceBackgroundStyle = true;
      this.configBackgroundStyle = false;
      this.patchBackgroundStyle = false;
    }
    if (location.indexOf('userManagement') > 0) {
      this.deviceBackgroundStyle = false;
      this.configBackgroundStyle = true;
      this.patchBackgroundStyle = false;
    }
    if (location.indexOf('patchManagement') > 0) {
      this.patchBackgroundStyle = true;
      this.deviceBackgroundStyle = false;
      this.configBackgroundStyle = false;
    }
  }

  public navigateToDeviceDetails() {
    this.applyStyleToNavigations('/deviceDetails');
    this.router.navigate(['/deviceDetails']);
  }

  public navigateToUserManagement() {
    //this.applyStyleToNavigations('/userManagement');
    this.router.navigate(['/userManagement']);
  }
  public navigateToPatchManangement() {
    // this.applyStyleToNavigations('/patchManagement');
    this.router.navigate(['/patchManagement']);
  }
  
  mouseOverInOnUser() {
    this.logoutImgSrc = '../../../assets/icons/logout.svg';
    this.usrImgSrc = '../../../assets/icons/user.svg';
  }

  mouseOverOutOnUser() {
    this.logoutImgSrc = '../../../assets/icons/user.svg';
    this.usrImgSrc = '../../../assets/icons/logout.svg';
  }

  initiateLogout() {
    if (this.blobServiceClientService.isUploadInProgress()) {
      this.dialog.open(LogoutPatchUploadPopupComponent, {
        disableClose: true,
        autoFocus: false
      }).afterClosed().subscribe((result: boolean) => {
        if (!result) {
          this.blobServiceClientService.cancelAllPatchUploads().finally(() => {
            this.messageBroadcastService.broadCast({event:BroadcastMessageEvent.patchProgressUpdates});
            this.logout();
          })
        }
      })
    }
    else {
      this.logout();
    }
  }


  logout() {
      sessionStorage.removeItem("SingleSessionlogoutUser");
      this.logoutService.userLoggedOut();
      this.msalService.logoutRedirect();
  }
  toggleLogout(){
    this.isLogoutClicked = !this.isLogoutClicked;
  }

  setServiceKey(){
    this.dialog.open(SetServiceKeyComponent, {
      disableClose: true,
      autoFocus: false,
      data: {}
    })
  }

  getUserServiceKeyStatus() { 
    this.suaService.getUserServiceKeyStatus().subscribe(data=>{
      if(data == UserServiceKeyStatus.NoKey || data == UserServiceKeyStatus.ExpiredKey){
        //add amber
        this.showCautionBanner = true;
        this.tooltipDynamicContentValue = data == UserServiceKeyStatus.NoKey ? "not configured" : "expired";
        this.dialogData = data;
      }
      else{
        this.showCautionBanner = false;
        this.dialogData = {};
      }
    })
  }
  closeLogoutWindow(){
    this.isLogoutClicked = false;
  }
  ngOnDestroy(): void {
    this.roleUpdateSubscription?.unsubscribe();
    this.suaKeyUpdateSubscription?.unsubscribe();
  }
  @ViewChild(TabContainerComponent) tabContainerComponent;
  @ViewChild(TabComponent) tabComponent;
  @ViewChild(NavbarComponent) navbarcomponent;
  deviceBackgroundStyle: boolean = false;
  configBackgroundStyle: boolean = false;
  patchBackgroundStyle: boolean = false;
  deviceSummaryComponent;
}                                                                                     